<template>
  <div>
    <!-- Start of tribe review dialog -->
    <v-card>
      <v-toolbar flat>
        <span class="headline">TRIBE REVIEW</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="hideDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="2">
            <span style="color: #9C27B0!important">
              <i class="fas fa-square"></i>
              Same Day
            </span>
          </v-col>
          <v-col cols="8"></v-col>
          <v-col cols="2">
            <v-btn
              dark
              small
              tile
              color="primary"
              class="btn-action p-r-4 m-b-10"
              @click="triggerBatchApproveDialog(true)">
              Batch Approve
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          fixed-header
          :headers="headers"
          :items="dataSource"
          :footer-props="footerProps"
          :options.sync="options"
          :server-items-length="options.pageCount"
          :loading="loading"
          class="elevation-1"
          height="450"
        >
          <template v-slot:item="{ item }">
            <tr :class="colorSameDay(item)">
              <td>{{ item.loanNo }}</td>
              <td>{{ assist.tool.getFullName(item) }}</td>
              <td>{{ assist.tool.formatCurrency(item.approvedAmount) }}</td>
              <td>{{ assist.tool.formatDate(item.effectiveDate) }}</td>
              <td>{{ assist.tool.formatDate(item.enteredAt) }}</td>
              <td>{{ item.totalScore }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <!-- End of tribe review dialog -->

    <!-- Start of batch approve dialog -->
    <v-dialog max-width="500px" v-model="batchApproveDialog" persistent>
      <v-card>
        <v-toolbar flat>
          <span class="headline">BATCH APPROVE</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="triggerBatchApproveDialog(false)">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="p-t-20">
          <ValidationObserver ref="observer" v-slot="{ validate, reset }">
            <v-row v-if="false">
              <v-col cols="6" class="batch-approve-text">Portfolio</v-col>
              <v-col cols="6" class="batch-approve-field">
                <ValidationProvider :name="label.portfolioId" :rules="rules.portfolioId" v-slot="{ errors }">
                  <v-select
                    hide-details="auto"
                    v-model="batchApproveCondition.portfolioId"
                    :error-messages="errors[0]"
                    :items="portfolioItems"
                    item-value="id"
                    item-text="portfolioName"
                  ></v-select>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="batch-approve-text">Disbursement Date</v-col>
              <v-col cols="6" class="batch-approve-field">
                <ValidationProvider :name="label.effectiveDate" rules="required" v-slot="{ errors }">
                  <date-picker-menu
                    hide-details="auto"
                    v-model="batchApproveCondition.effectiveDate"
                    allowed="start-now"
                    :error-messages="errors[0]"
                  ></date-picker-menu>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="batch-approve-text">Minimum Score to Approve</v-col>
              <v-col cols="6" class="batch-approve-field">
                <ValidationProvider :name="label.score" :rules="rules.score" v-slot="{ errors }">
                  <v-text-field
                    hide-details="auto"
                    type="number"
                    v-model="batchApproveCondition.score"
                    :error-messages="errors[0]"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </ValidationObserver>
          <v-row style="margin-top: 15px;">
            <v-col cols="12" class="start-batch-approve">
              <v-btn
                dark
                tile
                color="primary"
                class="btn-action"
                @click="batchApprove()"
                :loading="startBatchApproveLoading"
              >Start</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End of batch approve dialog -->
  </div>
</template>

<script>
import { DataType, Popup, Tool } from '@/util/index'
import { LIST_TABLE_HEADER } from '@/setting/list-header/list-table-header'
import DatePickerMenu from '@/components/widget/input/DatePickerMenu'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { LoanResourceApi, RuntimeApi, LoanOperationApi } from '@/api/pandaria'

const popup = new Popup()
const tool = new Tool()
export default {
  name: 'batch-approve-dialog',
  components: {
    DatePickerMenu,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    beginDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    },
    display: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataType: DataType,
      headers: LIST_TABLE_HEADER.TribeReviewBatchApproveHeader,
      dataSource: [],
      loading: false,
      startBatchApproveLoading: false,
      batchApproveDialog: false,
      batchApproveCondition: {
        portfolioId: [],
        effectiveDate: tool.formatDate(new Date().getTime()),
        score: null
      },
      label: {
        portfolioId: 'Portfolio',
        effectiveDate: 'Disbursement Date',
        score: 'Minimum Score'
      },
      rules: {
        portfolioId: 'required',
        effectiveDate: 'required',
        score: 'required|min_value:1|max_value:10'
      },
      portfolioItems: [],
      footerProps: {
        'items-per-page-options': [10, 20, 50]
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        pageCount: 0
      },
      assist: {
        tool: tool
      }
    }
  },
  watch: {
    'store.getters.getAccount': function (val) {
      const portfolioIdList = val.portfolioIdList
      this.listPortfolio(portfolioIdList)
    },
    'options.page': {
      handler () {
        this.searchData()
      }
    },
    'options.itemsPerPage': {
      handler () {
        this.searchData()
      }
    },
    display: {
      handler: function (val) {
        if (val) {
          this.searchData()
        }
      },
      immediate: true
    }
  },
  mounted () {
    const $this = this
    const account = $this.store.getters.getAccount
    if (tool.isNotEmpty(account)) {
      const portfolioIdList = account.portfolioIdList
      $this.listPortfolio(portfolioIdList)
    }
  },
  methods: {
    colorSameDay (itemData) {
      let result = ''
      if (tool.isNotEmpty(itemData)) {
        const effectiveDate = tool.isNotEmpty(itemData.effectiveDate) ? parseInt(itemData.effectiveDate) : 0
        const currentTimestamp = tool.isNotEmpty(itemData.currentTimestamp) ? parseInt(itemData.currentTimestamp) : 0
        if (effectiveDate >= currentTimestamp && effectiveDate <= currentTimestamp + 24 * 3600 * 1000 - 1) {
          result = 'text-purple-500 bg-purple-500'
        }
      }
      return result
    },
    searchData () {
      const requestInput = {
        portfolioIds: this.store.getters.getRuntimePortfolio,
        loanStatuses: [DataType.LoanStatus.TRIBE_REVIEW.value],
        features: 'LOAN_PERSONAL_DATA, LOAN_OPERATION_DATA, LOAN_LOCK_DATA, LOAN_PAYMENT_OPTION_DATA, LOAN_STATUS_DATA, LOAN_QUALITY_DATA',
        page: this.options.page,
        phase: DataType.LoanPhaseEnum.LOAN_ORIGINATION.value,
        size: this.options.itemsPerPage,
        beginDate: this.beginDate,
        endDate: this.endDate
      }
      this.loading = true
      this.getQueueCount(requestInput)
      this.getQueueItems(requestInput)
    },
    async getQueueCount (requestInput) {
      const $this = this
      const { portfolioIds, loanStatuses, filter, beginDate, endDate } = requestInput
      const input = {
        portfolioIds: portfolioIds,
        loanStatuses: loanStatuses,
        filter: filter,
        phase: DataType.LoanPhaseEnum.LOAN_ORIGINATION.value,
        beginDate: beginDate,
        endDate: endDate
      }
      await LoanResourceApi.getWorkQueueCount(input, function (data) {
        $this.options.pageCount = tool.isEmpty(data) ? 0 : data
      }, function () {
        $this.options.pageCount = 0
      })
    },
    async getQueueItems (requestInput) {
      const $this = this
      $this.dataSource = []
      await LoanResourceApi.getWorkQueueItem(requestInput, function (data) {
        $this.dataSource = tool.isEmpty(data) ? [] : data
        $this.loading = false
      }, function () {
        $this.dataSource = []
        $this.loading = false
      })
    },
    batchApprove () {
      const $this = this
      this.$refs.observer.validate().then(result => {
        if (result) {
          const filter = {
            effectiveDate: $this.batchApproveCondition.effectiveDate,
            scoreCondition: $this.batchApproveCondition.score
          }
          const requestData = {
            portfolioIds: $this.store.getters.getRuntimePortfolio,
            loanStatuses: [DataType.LoanStatus.TRIBE_REVIEW.value],
            filter: filter,
            phase: DataType.LoanPhaseEnum.LOAN_ORIGINATION.value,
            beginDate: this.beginDate,
            endDate: this.endDate,
            features: 'LOAN_PERSONAL_DATA,LOAN_OPERATION_DATA,LOAN_PAYMENT_OPTION_DATA,LOAN_STATUS_DATA,LOAN_QUALITY_DATA'
          }
          $this.startBatchApproveLoading = true
          LoanResourceApi.getWorkQueueItem(requestData, function (data) {
            if (tool.isNotEmpty(data) && data.length > 0) {
              popup.popupForInfo(`There are ${data.length} loans will be batch approved, are you sure?`, { showCancelButton: true }, function () {
                const loanIds = []
                for (const item of data) {
                  loanIds.push(item.id)
                }
                const batchData = {
                  loanIds: loanIds,
                  status: DataType.LoanStatus.APPROVED.value
                }
                LoanOperationApi.batchUpdateStatus(batchData, function (result) {
                  popup.popupForSuccess()
                  $this.startBatchApproveLoading = false
                  $this.batchApproveDialog = false
                  $this.hideDialog()
                  $this.$eventBus.$emit('initWorkQueue')
                }, function (result) {
                  $this.startBatchApproveLoading = false
                  popup.popupForWarning(result.message)
                })
              }, function (result) {
                $this.startBatchApproveLoading = false
                popup.popupForWarning(result.message)
              })
            } else {
              $this.startBatchApproveLoading = false
              popup.popupForWarning('There is no loan needs to be approved')
            }
          }, function (result) {
            $this.startBatchApproveLoading = false
            popup.popupForWarning(result.message)
          })
        }
      })
    },
    listPortfolio (portfolioIdList) {
      const $this = this
      let portfolioArray = $this.store.getters.getPortfolioArrayWithEmployeeId
      if (tool.isEmpty(portfolioArray)) {
        portfolioArray = []
        RuntimeApi.listPortfolioByCompanyId(function (result) {
          for (let item of result) {
            if (typeof item === 'string') {
              item = JSON.parse(item)
            }
            if (portfolioIdList.includes(item.id)) {
              portfolioArray.push(item)
              $this.batchApproveCondition.portfolioId.push(item.id)
            }
          }
          $this.portfolioItems = portfolioArray
          $this.store.commit('setPortfolioArray', portfolioArray)
        })
      } else {
        $this.portfolioItems = portfolioArray
      }
    },
    hideDialog () {
      this.$emit('hideDialog')
    },
    triggerBatchApproveDialog (flag) {
      this.batchApproveDialog = flag
    }
  }
}
</script>

<style>
  .v-textarea textarea {
    resize: none;
  }
  .batch-approve-text {
    padding-top: 20px;
    font-weight: bold;
  }
  .batch-approve-field {
    padding: 0 12px
  }
  .start-batch-approve {
    display: flex;
    justify-content: center;
    margin-top: 15px;
    padding: 0
  }
</style>
